import { useState, useEffect } from 'react'
import { useHistory, useLocation, Link } from 'react-router-dom'
import { env, getEnvBoolean } from 'srs.sharedcomponents/lib/esm/api/env'
import { ContextMenu, Group, Label, Menu } from '../styles'
import {
  useAppDispatch,
  useAppSelector,
} from 'srs.sharedcomponents/lib/esm/redux/hooks'
import { selectCartItemsCount } from 'srs.sharedcomponents/lib/esm/redux/slices/cartSlice'
import {
  dealershipName,
  bearerToken,
  fullName,
  dealershipID,
} from 'srs.sharedcomponents/lib/esm/redux/slices/userSlice'
import { stringToBoolean } from 'srs.sharedcomponents/lib/esm/utils/helpers'
import { CustomHeaderProps } from '../index'
import { MenuHeaders } from '../components/MenuHeaders'
import { Search } from '../search'
import { useTranslate } from 'srs.sharedcomponents/lib/esm/hooks/useTranslate'
import { getWebsiteName } from 'srs.sharedcomponents/lib/esm/utils/websiteName'
import TopNavigationComponent from 'srs.sharedcomponents/lib/esm/components/header/srs.topNavigation.component'
import CartButton from 'srs.sharedcomponents/lib/esm/components/molecules/Navbar/CartButton/CartButton'
import HoverTooltip from '../../HoverTooltip'
import { IMainMenuItem } from 'srs.sharedcomponents/lib/esm/models/srs.mainMenuItem.model'
import { selectLoanCartItemsCount } from 'srs.sharedcomponents/lib/esm/redux/slices/loanCartSlice'
import { selectWishListItems } from 'srs.sharedcomponents/lib/esm/redux/slices/wishlistSlice'
import { Chevron } from './prototype'
import { Container, Row } from 'react-bootstrap'
import { MenuContainer, TopNavigationWrapper } from '../styles'
import LoanCartButton from 'srs.sharedcomponents/lib/esm/components/molecules/Navbar/LoanCartButton/LoanCartButton'
import LogoComponent from 'srs.sharedcomponents/lib/esm/components/atoms/Logocomponent/LogoComponent'
import { LinkType } from 'srs.sharedcomponents/lib/esm/utils/enums'
import {
  mainMenuItems,
  siteSettings,
} from 'srs.sharedcomponents/lib/esm/redux/slices/welcomeSlice'
import ToolNetLinkComponent from 'srs.sharedcomponents/lib/esm/components/organisms/ToolNetLink/ToolNetLink'
import { i18nNamespaces as namespace } from 'srs.sharedcomponents/lib/esm/i18n/i18n'
import { setSearchParam } from 'srs.sharedcomponents/lib/esm/redux/slices/productlistSlice'
import { usePendoInitialization } from 'srs.sharedcomponents/lib/esm/components/organisms/Header/helpers/usePendoInitialization'

export interface IHeaderComponentProps {
  toggleLeftSideMobileMenu?: () => void
  additionalMenuItemsRight?: IMainMenuItem[]
}

export interface HeaderWebProps extends CustomHeaderProps {
  toolNetLink?: IMainMenuItem
  isInventoryAdministrator?: boolean
  regionLogoText: string
}

const HeaderWeb = (props: HeaderWebProps) => {
  const { toolNetLink, isInventoryAdministrator, regionLogoText } = props
  const { translate } = useTranslate()
  const history = useHistory()
  const location = useLocation()
  const wishlistItems = useAppSelector(selectWishListItems)
  const wishlistItemsCount = wishlistItems?.length ?? 0
  const [cartCount, setCartCount] = useState<string>('0')
  const [wishlistCount, setWishlistCount] = useState<string>('0')
  const fullWidthLayout = stringToBoolean(
    process.env.REACT_APP_FULL_WIDTH_LAYOUT,
  )
  const dispatch = useAppDispatch()
  let menuItems = useAppSelector(mainMenuItems)
  menuItems = Array.isArray(menuItems)
    ? menuItems.filter((item) => item.linkType != LinkType.ToolNet)
    : menuItems
  const user = useAppSelector((state) => state.user.user)
  const userLoggedIn = !!useAppSelector(bearerToken)
  const cartItemsCount = useAppSelector(selectCartItemsCount)
  const fullNameDb = useAppSelector(fullName)
  const dealershipNameDb = useAppSelector(dealershipName)
  const dealershipIdDb = useAppSelector(dealershipID)
  const siteSettingsSlice = useAppSelector(siteSettings)
  const isDockUsMode = getEnvBoolean('REACT_APP_DOCK_US_MODE')

  const website = getWebsiteName()
  const { push } = useHistory()
  const [hoverState, setHoverState] = useState<{ [key: string]: boolean }>({})

  const loanCartItemsCount: number = useAppSelector(selectLoanCartItemsCount)

  const isLoanEnabled = useAppSelector((state) => state?.user.user?.rentEnabled)

  const handleHover = (key: string, value: boolean) => {
    setHoverState((prevState) => ({ ...prevState, [key]: value }))
  }

  const getLinkProps = (item: IMainMenuItem) => {
    const isExternal =
      item.placementType?.toLowerCase() === 'builder' ||
      item.linkType === LinkType.ReactExt ||
      item.linkType === LinkType.ReactFilesLink
    return {
      to: item.url,
      target: isExternal ? item.placementType || '_blank' : undefined,
      external: isExternal,
      id: 'headerMenuOption_' + item.name.trim(),
    }
  }

  const handleMenuClick = (item: any, event: React.MouseEvent) => {
    const linkProps = getLinkProps(item)
    if (linkProps.external) {
      event.preventDefault()
      window.open(linkProps.to, linkProps.target || '_blank')
    } else if (linkProps.to && linkProps.to !== '#') {
      event.preventDefault()
      push(linkProps.to)
    } else {
      event.preventDefault()
    }
  }

  const renderMenuItems = (items: any[]) =>
    items.map((item) => {
      const linkProps = getLinkProps(item)
      return (
        <Label
          key={item.id}
          style={{ width: 'auto' }}
          href={item.children && item.children.length > 0 ? '#' : linkProps.to || '#'}
          onMouseEnter={() => item.children && handleHover(item.id, true)}
          onMouseLeave={() => item.children && handleHover(item.id, false)}
          onClick={
            item.children && item.children.length > 0
              ? (event) => {
                  event.preventDefault()
                }
              : (event) => {
                  handleMenuClick(item, event)
                  dispatch(setSearchParam(''))
                }
          }
          id={item.name}
        >
          {item.children && item.children.length > 0 ? (
            <Chevron isHovered={!!hoverState[item.id]}>{item.name}</Chevron>
          ) : linkProps.external ? (
            <a
              href={linkProps.to}
              target={linkProps.target || '_blank'}
              rel="noopener noreferrer"
              style={{ color: 'inherit', textDecoration: 'none' }}
              onClick={(e) => e.stopPropagation()}
            >
              {item.name}
            </a>
          ) : (
            <span>{item.name}</span>
          )}
          {item.children && item.children.length > 0 && hoverState[item.id] && (
            <ContextMenu css={contextMenuStyle}>
              <MenuHeaders
                headers={item.children}
                onMenuClick={handleMenuClick}
                getLinkProps={getLinkProps}
              />
            </ContextMenu>
          )}
        </Label>
      )
    })

  const contextMenuStyle = {
    backgroundColor: '#F2F5F8',
    padding: '0px',
    gap: '0px !important',
    border: '1px solid #CFD7E4',
    '&::after': {
      display: 'none',
    },
  }
  useEffect(() => {
    if (cartItemsCount !== null) {
      cartItemsCount > 99
        ? setCartCount('99+')
        : setCartCount(cartItemsCount.toString())
    }
  }, [cartItemsCount])

  useEffect(() => {
    if (wishlistItemsCount !== null && wishlistItemsCount !== undefined) {
      wishlistItemsCount > 99
        ? setWishlistCount('99+')
        : setWishlistCount(wishlistItemsCount.toString())
    }
  }, [wishlistItemsCount])

  useEffect(() => {
    const meta = document.createElement('meta')
    meta.httpEquiv = 'Content-Security-Policy'
    meta.content =
      "default-src 'self' *.adyen.com *.bosch-automotive.com *.cardinalcommerce.com *.youtube.com *.americanexpress.com *.vids.io *.pendo.io *.builder.io; " +
      "img-src 'self' *.bosch-automotive.com *.google-analytics.com *.w3.org data: *.google.com  *.adyen.com *.cardinalcommerce.com *.americanexpress.com *.bosch.com *.googletagmanager.com *.google.co.id *.pendo.io *.storage.googleapis.com *.builder.io; " +
      "script-src 'self' 'unsafe-hashes' 'unsafe-eval' 'unsafe-inline' 'strict-dynamic' *.bosch.com *.google-analytics.com *.googletagmanager.com *.adyen.com *.americanexpress.com *.cardinalcommerce.com *.azure.com *.bosch-automotive.com *.dock.ui.bosch.tech *.btm.bosch.com *.bosch.tech *.pendo.io *.storage.googleapis.com *.builder.io; " +
      "style-src 'self' 'unsafe-inline' *.adyen.com *.cardinalcommerce.com *.americanexpress.com *.bosch.com *.fontawesome.com *.pendo.io *.storage.googleapis.com *.builder.io; " +
      "connect-src 'self' *.bosch.com *.google-analytics.com *.googletagmanager.com *.g.doubleclick.net *.americanexpress.com *.azure.com *.adyen.com *.cardinalcommerce.com *.bosch-automotive.com *.service-solutions.com *.services.visualstudio.com *.bosch.tech localhost:* *.pendo.io *.storage.googleapis.com bam.nr-data.net *.builder.io *.oktapreview.com *.allisontransmission.com *.apisandbox.zuora.com; " +
      "font-src 'self' *.adyen.com *.cardinalcommerce.com *.americanexpress.com *.bosch.com *.fontawesome.com data: *.builder.io *.gstatic.com *.cloudflare.com; " +
      "frame-src 'self' *.adyen.com *.bosch-automotive.com *.youtube.com *.cardinalcommerce.com *.americanexpress.com *.vids.io *.pendo.io *.builder.io *.google.com *.flipsnack.com blob: *.zuora.com *.oktapreview.com *.allisontransmission.com; " +
      "child-src 'self' *.adyen.com *.cardinalcommerce.com *.americanexpress.com *.bosch-automotive.com *.pendo.io *.builder.io; " +
      "form-action 'self' *.googletagmanager.com *.adyen.com *.bosch.com *.bosch-automotive.com *.americanexpress.com *.cardinalcommerce.com *.dock.ui.bosch.tech *.btm.bosch.com *.bosch.tech *.service-solutions.com *.pendo.io *.builder.io; " +
      'worker-src blob:;'

    document.head.appendChild(meta)

    return () => {
      document.head.removeChild(meta)
    }
  }, [])

  usePendoInitialization({
    isDockUsMode,
    locationSearch: location.search,
    user,
    userLoggedIn,
    websiteName: website?.websiteName,
  })

  const handleClick = () => {
    history.push('/')
  }
  const keyEvents = new Set([' ', 'Enter'])

  return (
    <Container
      fluid={fullWidthLayout}
      className="header__menu d-none d-lg-block"
      id="headerLayout4"
    >
      <div className="container">
        <Row>
          <TopNavigationWrapper>
            <TopNavigationComponent />
          </TopNavigationWrapper>
        </Row>

        <Row
          style={{
            backgroundColor: '#EDF0F4',
          }}
        >
          <div
            role="button"
            onClick={handleClick}
            tabIndex={0}
            onKeyDown={(e) => {
              if (keyEvents.has(e.key)) handleClick()
            }}
            style={{
              margin: '18px 0 18px 0',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
            }}
          >
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
              }}
            >
              <LogoComponent
                logoUrl={`${process.env.PUBLIC_URL}/images/FG_Logo.svg`}
                containerWidth="auto"
              />
              <span
                style={{
                  fontSize: '28px',
                  color: '#00095B',
                  fontWeight: 'bold',
                  marginLeft: '8px',
                }}
              >
                {translate(regionLogoText)}
              </span>
            </div>
            <div style={{ position: 'relative' }}>
              {toolNetLink && isInventoryAdministrator && (
                <ToolNetLinkComponent
                  linkToToolNetUrl={toolNetLink.url || ''}
                  toolnetName={toolNetLink.name}
                  isHeader={true}
                />
              )}
            </div>
          </div>
        </Row>
        <Row>
          <div
            style={{
              display: 'flex',
              alignItems: 'baseline',
              justifyContent: 'space-between',
              width: '100%',
              backgroundColor: 'rgba(207, 215, 228, 100)',
            }}
            className="header-search-row"
          >
            <div
              style={{
                marginRight: 'auto',
                display: 'flex',
                alignItems: 'baseline',
                gap: 8,
                position: 'relative',
              }}
              className="header-welcome-text"
            >
              <Link to={process.env.REACT_APP_LOGO_REDIRECTURL ?? '/'}>
                <img
                  src={`${process.env.PUBLIC_URL}/images/Home-icon-with-drop-shadow-effect.svg`}
                  alt="Home"
                />
              </Link>

              <div style={{ position: 'relative', top: '3px' }}>
                <span
                  style={{
                    fontWeight: 'bold',
                    fontSize: '16px',
                    color: '#00095B',
                    position: 'relative',
                  }}
                >
                  {translate(`txtWelcomeMessage`, {
                    ns: namespace.coreSrsPrimary,
                  })}{' '}
                  {siteSettingsSlice?.['Srs.WelcomeControlFormat']?.includes(
                    'UserName',
                  ) && fullNameDb}
                  {siteSettingsSlice?.['Srs.WelcomeControlFormat']?.includes(
                    'CompanyName',
                  ) &&
                    dealershipNameDb &&
                    ', ' + dealershipNameDb}
                  {siteSettingsSlice?.['Srs.WelcomeControlFormat']?.includes(
                    'DealerShipID',
                  ) &&
                    dealershipIdDb &&
                    ', ' + dealershipIdDb}
                  <span className="ml-1" id="loginname"></span>{' '}
                </span>
              </div>
            </div>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                marginLeft: 'auto',
                gap: '1rem',
                marginTop: '4px',
              }}
              className="header-search-container"
            >
              <Search />
              <HoverTooltip message={translate('txtWishListToolTip')}>
                <Link to={'/wishlist'}>
                  <img
                    src={`${process.env.PUBLIC_URL}/images/Wishlist-icon-with-dropshadow-effect.svg`}
                    style={{
                      marginBottom: '0.3rem',
                      height: '40px',
                    }}
                    alt="wishlist icon"
                  ></img>
                </Link>
              </HoverTooltip>
              {userLoggedIn && (
                <HoverTooltip message={translate('txtCartToolTip')}>
                  <CartButton
                    cartCount={cartCount}
                    isCartEnabled
                    style={{
                      borderRadius: '8px',
                      boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
                      backgroundColor: '#CFD7E4',
                      padding: '3px',
                      fontSize: '1.7rem',
                    }}
                  />
                </HoverTooltip>
              )}
              {userLoggedIn && (
                <HoverTooltip message={translate('txtRentalCart')}>
                  <LoanCartButton
                    style={{
                      borderRadius: '8px',
                      boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
                      backgroundColor: '#CFD7E4',
                      width: '36px',
                      height: '32px',
                      paddingTop: '14px',
                      position: 'relative',
                      top: '-2px',
                    }}
                    loanCartItemsCount={loanCartItemsCount}
                    isLoanEnabled={isLoanEnabled}
                  />
                </HoverTooltip>
              )}
            </div>
          </div>
        </Row>
        <Row style={{ minHeight: '3em', backgroundColor: '#F2F5F8' }}>
          <MenuContainer className="header-group">
            <Group style={{ width: 'auto' }} className="header-product-group">
              <Menu>{renderMenuItems(menuItems || [])}</Menu>
            </Group>
          </MenuContainer>
        </Row>
      </div>
    </Container>
  )
}

export { HeaderWeb }
